import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

// Live countdown driven by the server's Brisbane-time deadline (never the visitor's clock for the deadline itself).
export default function PupCountdown({ closesAt, serverNow, compact = false }) {
  const [offset] = useState(() => (serverNow ? Date.parse(serverNow) - Date.now() : 0));
  const [left, setLeft] = useState(() => Date.parse(closesAt) - (Date.now() + offset));
  useEffect(() => {
    const t = setInterval(() => setLeft(Date.parse(closesAt) - (Date.now() + offset)), 1000);
    return () => clearInterval(t);
  }, [closesAt, offset]);
  if (!closesAt) return null;
  if (left <= 0) return <span className="inline-flex items-center gap-1.5 text-sm font-bold text-[#19324A]" data-testid="pup-countdown-closed"><Clock className="w-4 h-4" /> Voting closed — results on the 1st</span>;
  const s = Math.floor(left / 1000);
  const parts = [["d", Math.floor(s / 86400)], ["h", Math.floor((s % 86400) / 3600)], ["m", Math.floor((s % 3600) / 60)], ["s", s % 60]];
  if (compact) return <span className="text-xs font-bold text-[#19324A]" data-testid="pup-countdown">{parts.map(([u, v]) => `${v}${u}`).join(" ")} left</span>;
  return (
    <div className="inline-flex items-center gap-2" data-testid="pup-countdown" aria-live="off">
      {parts.map(([u, v]) => (
        <span key={u} className="min-w-[56px] rounded-2xl bg-[#19324A] text-white text-center py-1.5 px-2">
          <span className="block font-display font-extrabold text-xl leading-none tabular-nums">{String(v).padStart(2, "0")}</span>
          <span className="block text-[10px] uppercase tracking-wider text-white/70">{{ d: "days", h: "hrs", m: "min", s: "sec" }[u]}</span>
        </span>
      ))}
    </div>
  );
}
